<template>
  <div>
    <!-- <pre>
    {{ cluster }}
    </pre>
    {{ '==================' }}
    <pre>
    {{ values }}
    </pre> -->
    <table id="tabCluster">
      <tr>
        <td class="desc-title headTd">{{ $t("message.callStation") }}</td>
        <td class="headTd" colspan="2">PRA-CSLD / PRA-CSLW</td>
      </tr>
      <tr v-if="(Number(desktop) + Number(wallmount)) > 2">
        <td class="device-content" colspan="3"><span :class="((Number(desktop) + Number(wallmount)) > 2) ? 'warning' : 'success'" v-html="$t('message.zasilacz_mps')"></span></td>
      </tr>
      <tr>
        <td>{{ $t("message.callStationDesktop") }}</td>
        <td class="device-content"><span :class="((Number(desktop) + Number(wallmount)) > 2) ? 'warning' : 'success'">PRA-CSLD</span>

          <!-- <md-avatar v-if="(Number(desktop) + Number(wallmount)) > 2" style="width: 16px;min-width: 22px;height: 16px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-info-square-fill" viewBox="0 0 16 16" style="margin-right: 0px; color: #3ba3ff;cursor: pointer;width:18px;position: relative;top: 0px;">
            <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm8.93 4.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
            </svg>
            <md-tooltip md-direction="right" class="tooltipImg" style="transition-delay: 0ms;width: 485px;height: 60px;position: absolute;top: 520px;left: 670px;will-change: top, left;font-size: 16px;" v-html="$t('message.zasilacz_mps')">
            </md-tooltip>
          </md-avatar> -->

        </td>
        <td class="qty-content">
          <!-- <input type="number" class="form-control form-control-sm" min=0 :max="2 - Number(wallmount)"
          v-model.lazy="desktop" @change="inputValue()"/> -->
          <select class="form-control form-control-sm" style="width: 70px;" name="" id="" v-model="desktop" @change="inputValue()">
            <option v-for="n in maxDesktop + 1" :key="n" :value="n - 1">
              {{ n - 1 }}
            </option>
          </select>
        </td>
      </tr>
      <tr>
        <td>{{ $t("message.callStationWall") }}</td>
        <td class="device-content"><span :class="((Number(desktop) + Number(wallmount)) > 2) ? 'warning' : 'success'">PRA-CSLW</span></td>
        <td class="qty-content">
          <!-- <input type="number" class="form-control form-control-sm" min=0 :max="2 - Number(desktop)"
          v-model.lazy="wallmount" @change="inputValue()"/> -->
          <select class="form-control form-control-sm" style="width: 70px;" name="" id="" v-model="wallmount" @change="inputValue()">
            <option v-for="n in maxWallmount + 1" :key="n" :value="n - 1">
              {{ n - 1 }}
            </option>
          </select>
        </td>
      </tr>
      <tr>
        <td>{{ $t("message.callStationExt") }}</td>
        <td class="device-content">PRA-CSE</td>
        <td class="qty-content">
          <!-- <input type="number" class="form-control form-control-sm" min=0 :max="maxExt"
          v-model.lazy="extension" @change="inputValue()"/> -->
          <select class="form-control form-control-sm" style="width: 70px;" name="" id="" v-model="extension" @change="inputValue()">
            <option v-for="n in maxExt+1" :key="n" :value="n - 1">
              {{ n - 1 }}
            </option>
          </select>
        </td>
      </tr>
      <tr>
        <td></td>
        <td class="device-content">{{ $t("message.totalPoeCST") }}</td>
        <td class="qty-content">
          <!-- <input type="number" class="form-control form-control-sm" :min="minPoE" :max="maxPoE"
          v-model.lazy="poe" @change="inputValue()"/> -->
          <select class="form-control form-control-sm" style="width: 70px;" name="" id="" v-model="poe" @change="inputValue()">
            <option v-for="n in maxPoE+1" :key="n" :value="n - 1">
              {{ n - 1 }}
            </option>
          </select>
        </td>
      </tr>
      <tr>
        <td></td>
        <td class="device-content">{{ $t("message.classEmerdencyCST") }}</td>
        <td class="qty-content">
          <!-- <input type="number" class="form-control form-control-sm" min=0 :max="maxCst"
          v-model.lazy="cst" @change="inputValue()"/> -->
          <select class="form-control form-control-sm" style="width: 70px;" name="" id="" v-model="cst" @change="inputValue()">
            <option v-for="n in maxCst+1" :key="n" :value="n - 1">
              {{ n - 1 }}
            </option>
          </select>
        </td>
      </tr>
      <tr class="wiersz-pusty"></tr>

    </table>
  </div>
</template>

<script>
import { app } from '../../mixins/app'
import { mapGetters } from 'vuex'

export default {
  name: 'CallStation',
  props: ['title', 'values', 'clear', 'cluster'],
  mixins: [app],
  data () {
    return {
      desktop: 0,
      wallmount: 0,
      extension: 0,
      poe: 0,
      cst: 0
    }
  },
  watch: {
    clearing (newValue, oldValue) {
      if (newValue === true) {
        this.desktop = 0
        this.wallmount = 0
        this.extension = 0
        this.poe = 0
        this.cst = 0
      }
    },
    clear (newValue, oldValue) {
      if (newValue === true) {
        this.desktop = 0
        this.wallmount = 0
        this.extension = 0
        this.poe = 0
        this.cst = 0
      }
    },
    values (newValue, oldValue) {
      if (newValue !== null) {
        this.desktop = this.values.csDesktop
        this.wallmount = this.values.csWall
        this.extension = this.values.csExt
        this.poe = this.values.poePorts
        this.cst = this.values.cstEmergency
      }
    },
    desktop (newValue, oldValue) {
      this.poe = Number(newValue) + Number(this.wallmount)
    },
    wallmount (newValue, oldValue) {
      this.poe = Number(newValue) + Number(this.desktop)
    }
  },
  computed: {
    ...mapGetters('app', ['clearing']),
    // Suma wszystkich INNYCH komponentów (bez aktualnego)
    usedByOthers () {
      if (!this.cluster) return 0
      return (
        Number(this.cluster.noiseSensor ? this.cluster.noiseSensor.poePorts : 0) +
        Number(this.cluster.interfaceControl ? this.cluster.interfaceControl.poePorts : 0) +
        Number(this.cluster.interfaceAudio ? this.cluster.interfaceAudio.poePorts : 0) +
        Number(this.cluster.panelControl ? this.cluster.panelControl.poePorts : 0)
      )
    },

    // Max dla desktop = 2 - wallmount - inne komponenty
    maxDesktop () {
      if (this.cluster) {
        var ethernetPowerSupply = (this.cluster.powerSupply && this.cluster.powerSupply.ethernet) ? this.cluster.powerSupply.ethernet : 2
        var ethernetOutput48one = (this.cluster.output48one && this.cluster.output48one.selected === 'PRA-ES8P2S') ? this.cluster.output48one.ethernet : 0
        var ethernetOutput48two = (this.cluster.output48two && this.cluster.output48two.selected === 'PRA-ES8P2S') ? this.cluster.output48two.ethernet : 0
        var ethernetOutput48three = (this.cluster.output48three && this.cluster.output48three.selected === 'PRA-ES8P2S') ? this.cluster.output48three.ethernet : 0
        var allEthernets = Number(ethernetPowerSupply) + Number(ethernetOutput48one) + Number(ethernetOutput48two) + Number(ethernetOutput48three)
        return Math.max(0, allEthernets - Number(this.wallmount) - this.usedByOthers)
      }
      return 0
    },

    // Max dla wallmount = 2 - desktop - inne komponenty
    maxWallmount () {
      if (this.cluster) {
        var ethernetPowerSupply = (this.cluster.powerSupply && this.cluster.powerSupply.ethernet) ? this.cluster.powerSupply.ethernet : 2
        var ethernetOutput48one = (this.cluster.output48one && this.cluster.output48one.selected === 'PRA-ES8P2S') ? this.cluster.output48one.ethernet : 0
        var ethernetOutput48two = (this.cluster.output48two && this.cluster.output48two.selected === 'PRA-ES8P2S') ? this.cluster.output48two.ethernet : 0
        var ethernetOutput48three = (this.cluster.output48three && this.cluster.output48three.selected === 'PRA-ES8P2S') ? this.cluster.output48three.ethernet : 0
        var allEthernets = Number(ethernetPowerSupply) + Number(ethernetOutput48one) + Number(ethernetOutput48two) + Number(ethernetOutput48three)
        return Math.max(0, allEthernets - Number(this.desktop) - this.usedByOthers)
      }
      return 0
    },
    maxExt () {
      return (Number(this.desktop) + Number(this.wallmount)) * 4
    },
    minPoE () {
      return (Number(this.desktop) + Number(this.wallmount))
    },
    maxPoE () {
      var sum = ((Number(this.desktop) + Number(this.wallmount)) * 2 > 2) ? 2 : Number(this.desktop) + Number(this.wallmount)
      return sum
    },
    maxCst () {
      return (Number(this.desktop) + Number(this.wallmount))
    }
  },
  methods: {
    inputValue () {
      this.$emit('allValues', this.desktop, this.wallmount, this.extension, this.poe, this.cst)
    }
  }
}
</script>

<style>
.warning {
  color:crimson
}
</style>



// WEBPACK FOOTER //
// src/components/Devices/CallStation.vue